import styled, { css } from "styled-components";
import { colors } from "../../consts";
import { FlexContainers, Paragraph2 } from "../../components";

export const StatusIndicatorBackground = styled.div`
  background: ${colors.ISABELLINE};
  border-radius: 70px;

  position: relative;
`;

const ActiveStatusStyles = css`
  background: rgba(43, 186, 153, 0.1);

  ${Paragraph2} {
    color: ${colors.SUCCESS};
  }

  & span {
    background: ${colors.SUCCESS};
  }
`;

const InactiveStatusStyles = css`
  background: rgba(93, 89, 100, 0.1);

  ${Paragraph2} {
    color: ${colors.RAISIN_80};
  }

  & span {
    background: ${colors.RAISIN_80};
  }
`;

const DraftStatusStyles = css`
  background: rgba(93, 89, 100, 0.5);

  ${Paragraph2} {
    color: ${colors.WHITE};
  }

  & span {
    background: ${colors.WHITE};
  }
`;

export const StatusIndicatorWrapper = styled(FlexContainers.FlexRowStart)`
  height: 26px;
  padding: 0 10px;

  border-radius: 70px;

  ${(props) => props?.status === "active" && ActiveStatusStyles}
  ${(props) => props?.status === "inactive" && InactiveStatusStyles}
  ${(props) => props?.status === "draft" && DraftStatusStyles}

  ${Paragraph2} {
    font-weight: 700;
    font-size: 12px;
    line-height: 26px;

    letter-spacing: 0.6px;
    text-transform: uppercase;
  }

  & span {
    width: 8px;
    height: 8px;

    min-width: 8px;

    margin-right: 8px;

    border-radius: 50%;
  }
`;

export const WarningText = styled(Paragraph2)`
  position: absolute;
  width: 100%;
  color: ${colors.ERROR};

  font-size: 12px;
  line-height: 18px;
  text-align: center;

  bottom: -16px;
`;
